import { ButtonBase, FormControl, FormHelperText, FormLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as React from 'react';


export default function CustomIconButton({ iconName, onClick, color, backgroundColor, borderStyle, marginLeft, marginRight, height, borderRadius, paddingInline, paddingBlock }) {

    return (
        <>
            <ButtonBase
                style={{
                    border: borderStyle || "1.5px solid #D0D0D0",
                    paddingBlock: paddingBlock || 3,
                    paddingInline: paddingInline || 7,
                    borderRadius: borderRadius || 5,
                    marginLeft: marginLeft || 5,
                    backgroundColor: backgroundColor || 'white',
                    color: color || '#101010',
                }}
                onClick={()=> onClick()}
            >
                <i className={iconName}></i>
            </ButtonBase>
        </>
    );
}
